// extracted by mini-css-extract-plugin
export default {"label":"label_label__Xz90V","required":"label_required__fTFzF","alert":"label_alert__9c6aB"};